import { Component } from "react";
import { GlobalContext } from "../Context";
import ErrorPage from "../../Pages/ErrorPage";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.props.setError && this.props.setError(true);
    console.error(error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentPage !== this.props.currentPage) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    const { error } = this.state;

    const { optionState, userState } = this.context;
    const { nav, page } = optionState;

    const tags = {
      page: `${nav}-${page}`,
      profileId: userState?.profileID,
      project: userState.authUser?.auth.app.options.projectId,
      app: "tlc",
    };
    Object.entries(tags).forEach(([key, value]) => {
      Sentry.setTag(key, value);
    });

    return (
      <Sentry.ErrorBoundary fallback={<ErrorPage error={error} />}>
        {this.props.children}
      </Sentry.ErrorBoundary>
    );
  }
}

ErrorBoundary.contextType = GlobalContext;

export default ErrorBoundary;
